import { ComponentProps, PropsWithChildren } from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox, Input } from '@zep/ui';
import { cn } from '@zep/utils';
import S from './page.module.scss';
type RHFCheckboxGroupProps<T extends string> = PropsWithChildren<{
  name: T;
  nameClassName?: string;
  label: string;
  labelClassName?: string;
  description?: string;
  descriptionClassName?: string;
  contentClassName?: string;
  groupClassName?: string;
}>;
export const RHFCheckboxGroup = <T extends string,>(props: RHFCheckboxGroupProps<T>) => {
  const {
    name,
    label,
    description,
    children,
    nameClassName,
    labelClassName,
    descriptionClassName,
    contentClassName,
    groupClassName
  } = props;
  const {
    register,
    watch
  } = useFormContext();
  const isOpen = watch(name);
  return <div className={cn(S.field, groupClassName)} data-sentry-component="RHFCheckboxGroup" data-sentry-source-file="RHFCehckboxGroup.tsx">
      <label className={cn(S.field_label, labelClassName)}>
        <Checkbox {...register(name)} data-sentry-element="Checkbox" data-sentry-source-file="RHFCehckboxGroup.tsx" />
        <span className={cn(S.field_name, nameClassName)}>{label}</span>
      </label>
      {isOpen && description && <div className={cn(S.field_description, descriptionClassName)}>
          {description}
        </div>}
      {isOpen && children && <div className={cn(S.field_content, contentClassName)}>{children}</div>}
    </div>;
};

// ******************************************************

type RHFCheckboxGroupWithInputProps<T extends string> = RHFCheckboxGroupProps<T> & {
  inputProps: ComponentProps<typeof Input> & {
    name: string;
  };
};
export const RHFCheckboxGroupWithInput = <T extends string,>(props: RHFCheckboxGroupWithInputProps<T>) => {
  const {
    name,
    label,
    description,
    inputProps,
    children
  } = props;
  const {
    register,
    watch
  } = useFormContext();
  const isOpen = watch(name);
  const {
    className: inputClassName,
    name: inputName,
    ...inputRest
  } = inputProps;
  return <div className={S.field} data-sentry-component="RHFCheckboxGroupWithInput" data-sentry-source-file="RHFCehckboxGroup.tsx">
      <label className={S.field_label}>
        <Checkbox {...register(name)} data-sentry-element="Checkbox" data-sentry-source-file="RHFCehckboxGroup.tsx" />
        <span>{label}</span>
        <Input className={cn(S.input, inputClassName)} {...inputRest} {...register(inputName)} isDisabled={!isOpen} data-sentry-element="Input" data-sentry-source-file="RHFCehckboxGroup.tsx" />
      </label>
      {description && <div className={S.field_description}>{description}</div>}
      {isOpen && children && <div className={S.field_content}>{children}</div>}
    </div>;
};